export default function formField(fieldName, store) {
    return {
        // ne pas introduire d'état local, ni utiliser this
        init() {
            const input = this.$el.querySelector('input, select, textarea')
            if (input) {
                // initialise le store avec la valeur HTML (SSR / Symfony)
                store.initField(fieldName, input.value)
            }

        },

        get errorMessages() {
            return store?.getErrorMessages?.(fieldName) ?? [];
        },

        get hasError() {
            return store?.hasError?.(fieldName) ?? false;
        },

        get errorClass() {
            return (store?.hasError?.(fieldName) ?? false) ? 'has-error' : '';
        },

        /**
         * @deprecated
         */
        onBlur() {
           // store?.touch?.(fieldName);
        },

        onChange() {
            store?.touch?.(fieldName);
        }
    }
}
